<div class="tw-p-4">
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <div mat-dialog-title class="matp-dialog-title">テナント詳細情報</div>

  <mat-dialog-content class="tw-w-full tw-max-h-1/2 !tw-pt-1 tw-text-black">
    <div class="tw-flex tw-w-full tw-h-96 tw-m-auto tw-gap-12">
      <div class="tw-w-1/2">
        <div class="tw-h-20 tw-gap-8 tw-mb-5">
          <div class="tw-font-bold">テナント名</div>
          <div class="tw-ml-5">
            {{ tenantName }}
          </div>
        </div>
        <div class="tw-h-20">
          <div class="tw-font-bold">会社名</div>
          <div class="tw-ml-5">
            {{ companyName }}
          </div>
        </div>

        <!-- <div class="tw-h-20 tw-gap-7 tw-mb-5">
          <div class="tw-font-bold">会社ロゴ</div>
          <img
            src="{{ companyLogoPath }}"
            alt="ロゴ"
            class="tw-h-auto tw-max-h-full tw-ml-5"
          />
        </div> -->

        <div class="tw-gap-7 tw-mb-5">
          <div class="tw-h-20">
            <div class="tw-font-bold">説明</div>
            <div class="tw-ml-5">
              {{ description }}
            </div>
          </div>
        </div>
      </div>
      <div class="tw-w-1/2">
        <div class="tw-h-20 tw-mb-5">
          <div class="tw-font-bold">アカウント</div>
          <div class="tw-flex tw-ml-5">
            <span class="tw-min-w-[166px]">管理者数</span>
            <span class="tw-w-1/4">{{ adminCount }}</span>
          </div>
          <div class="tw-flex tw-ml-5">
            <span class="tw-min-w-[166px]">ユーザー数</span>
            <span class="tw-w-1/4">{{ userCount }}</span>
          </div>
        </div>
        <div class="tw-h-40 tw-mb-5">
          <div class="tw-font-bold">登録要素</div>
          <div class="tw-flex tw-ml-5">
            <span class="tw-min-w-[166px]">設定テンプレート数</span>
            <span class="tw-w-1/4">{{ assetTypeCount }}</span>
            <span class="tw-w-1/4"></span>
          </div>
          <div class="tw-flex tw-ml-5">
            <span class="tw-min-w-[166px]">配送数</span>
            <span class="tw-w-1/4">{{ shipmentCount }}</span>
            <span class="tw-w-1/4"></span>
          </div>
          <div class="tw-flex tw-ml-5">
            <span class="tw-min-w-[166px]">位置情報数</span>
            <span class="tw-w-1/4">{{ shipmentLocationCount }}</span>
            <span class="tw-w-1/4"></span>
          </div>
          <div class="tw-flex tw-ml-5">
            <span class="tw-min-w-[166px]">ルート数</span>
            <span class="tw-w-1/4">{{ shipmentRouteCount }}</span>
            <span class="tw-w-1/4"></span>
          </div>
        </div>
        <div class="tw-h-20 tw-mb-5">
          <div class="tw-font-bold">デバイス</div>
          <div class="tw-flex tw-ml-5" *ngFor="let device of deviceCounts">
            <span class="tw-min-w-[166px]">{{ device.deviceTypeDisplayName }}</span>
            <span class="tw-w-1/4"> {{ device.deviceCount }}</span>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4 tw-text-black"
  >
    <button
      id="btn-cancel-add-account"
      mat-raised-button
      mat-dialog-close
      class="tw-w-40"
    >
      <mat-icon>close</mat-icon>
      閉じる
    </button>
  </mat-dialog-actions>
</div>
